import { authContext } from "auth/auth.provider";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AppConsentedNotify = () => {
  const { appPermission,
    autoSyncDeadlineExist,
    // designatedUserData 
  } = useContext(authContext);
  const [isPermission, setPermission] = useState(false);

  useEffect(() => {
    if (appPermission) {
      if (!appPermission?.isMSGraphAppOnlyConsented || !appPermission.isMSGraphAppOnlyEnabled || !appPermission.isAdminConsented) {
        setPermission(true);
      }
    }

  }, [appPermission])

  const message =
  {
    consent: "Please click here to give enterprise permission or if you are not global admin copy and send the link to your admin",
    autoSync: "Some deadlines for the user in the firm are not synchronized. Click here to view details",
    invalidDesignatedToken: "Please verify the designated sync user to audit calendar accuracy. You may need to log in with that user"
  }

  return (
    <>
      {isPermission && (
        <div className="alert alert-danger mt-3 py-1 tooltip-bottom" role="alert" data-tooltip={message.consent}>
          <a
            href="https://login.microsoftonline.com/common/adminconsent?client_id=2fa142be-31b5-4fda-bd37-591541b501aa&redirect_uri=https://app.lawtoolbox.com/admin/apponlyconsent"
            target="_blank"
            className="link"
            rel="noreferrer"
          >
            {message.consent}
          </a>
        </div>
      )}
      {autoSyncDeadlineExist && (
        <div className="alert alert-danger mt-3 py-1 tooltip-bottom" role="alert" data-tooltip={message.autoSync}>
          {/* <a
            href="https://login.microsoftonline.com/common/adminconsent?client_id=2fa142be-31b5-4fda-bd37-591541b501aa&redirect_uri=https://app.lawtoolbox.com/admin/apponlyconsent"
            target="_blank"
            className="link"
            rel="noreferrer"
          >
            Please click here to give enterprise permission or if you are not global admin copy and send the link to your admin
          </a> */}
          <Link to="/event/auto-synced-audit-firm-deadlines">
            {message.autoSync}{" "}
          </Link>
          <a
            href="https://lawtoolbox.freshdesk.com/support/solutions/articles/16000231532-2-6-26-deadline-audit-tool"
            target="_blank"
            className="link"
            rel="noreferrer"
          >
            (Learn More)
          </a>
        </div>
      )}
      {/* {!designatedUserData.isDesignatedUserValid && (
        <div className="alert alert-danger mt-3 py-1 tooltip-bottom" role="alert" data-tooltip={message.invalidDesignatedToken}>
          <Link to="/firm/diagnostics">
            {message.invalidDesignatedToken}
          </Link>
        </div>
      )} */}
    </>
  )
}

export default AppConsentedNotify;
